export default "__VITE_ASSET__BFMwGQH1__"